var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 47,
    viewBox: "0 0 36 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9968 0V11.7476H36.0001L23.9968 0Z",
    fill: "#498CCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0843 14.6945C22.3431 14.6945 21.0008 13.3826 21.0008 11.7576V0.0100098H4.50365C2.02324 0.0100098 0 1.97773 0 4.41534V42.5949C0 45.0227 2.02324 47.0002 4.50365 47.0002H31.4964C33.9768 47.0002 35.9903 45.0227 35.9903 42.5949V14.6945H24.0843ZM12.1297 37.3476C10.2718 34.8807 9.69792 31.6697 10.6025 28.7132H10.8944C11.9449 28.7132 13.0051 28.8894 14.007 29.2418L13.9681 29.5355C13.9292 29.9663 13.9098 30.3872 13.9098 30.818C13.9098 34.724 15.6023 38.4735 18.5204 41.0383C16.0108 40.7251 13.7055 39.4035 12.1297 37.3476ZM20.0476 40.9405C16.8473 38.5909 14.9408 34.8317 14.9408 30.818C14.9408 30.4264 14.9408 30.025 14.9895 29.6432C16.3513 30.2893 17.5477 31.2683 18.4718 32.4822C20.3005 34.8904 20.8841 38.0329 20.0476 40.9405ZM21.2732 40.1671C21.7887 37.2595 21.0786 34.2248 19.2791 31.8557C18.2675 30.5145 16.9349 29.4278 15.4272 28.7034L15.1451 28.5663C15.719 25.3651 17.5282 22.4968 20.1837 20.5976C23.4715 22.9471 25.4364 26.7553 25.4364 30.818C25.4364 34.4108 23.9092 37.8078 21.2732 40.1671Z",
    fill: "#498CCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmission);
export default __webpack_public_path__ + "static/media/submission.0abec462edcad299a1ea76144dc3d2b9.svg";
export { ForwardRef as ReactComponent };